import * as onetrustConfig from '../../../../../onetrust.config.json'
import { Stage } from '@otto-ec/eprivacy-shared'
import { OnetrustSiteConfig } from '../../ports'

export function getOnetrustDataDomainScriptConfig(
  stage: Stage
): OnetrustSiteConfig {
  const domainScriptConfig = onetrustConfig[stage] ?? onetrustConfig.nonlive

  if (domainScriptConfig.id.endsWith('-test')) {
    return domainScriptConfig
  }

  const loadPreviewScript =
    location.href?.includes('otpreview=true') ||
    location.href?.includes('localhost') ||
    location.href?.includes('127.0.0.1')

  if (!loadPreviewScript) {
    return domainScriptConfig
  }

  return {
    id: domainScriptConfig.id + '-test',
    version: domainScriptConfig.version,
  }
}
